import React, { useEffect, useState, useContext } from 'react';
import { Modal, Tree, Result, Spin, Icon } from 'antd';
import { PContext } from '../../context/PendingContext';

const modalStyles = `
@keyframes od-bar   { 0%{background-position:0% center} 100%{background-position:200% center} }
@keyframes od-float { 0%,100%{transform:translateY(0px)} 50%{transform:translateY(-3px)} }
@keyframes od-glow  { 0%,100%{box-shadow:0 0 0 0 rgba(24,144,255,0.4)} 50%{box-shadow:0 0 0 10px rgba(0,0,0,0)} }
@keyframes modal-pop { from{opacity:0;transform:scale(0.96) translateY(12px)} to{opacity:1;transform:scale(1) translateY(0)} }
@keyframes od-spin-slow { 0%{transform:rotate(0deg)} 100%{transform:rotate(360deg)} }

/* ── Modal shell ── */
.od-modal .ant-modal-content { border-radius:14px!important; overflow:hidden!important; box-shadow:0 24px 64px rgba(0,0,0,.16),0 0 0 1px rgba(24,144,255,.1)!important; animation:modal-pop .3s cubic-bezier(.22,1,.36,1) both!important; }
.od-modal .ant-modal-header  { padding:0!important; border-bottom:none!important; }
.od-modal .ant-modal-body    { padding:0!important; }
.od-modal .ant-modal-footer  { display:none!important; }
.od-modal .ant-modal-close   { top:14px!important; right:16px!important; color:rgba(255,255,255,0.8)!important; transition:color .2s,transform .2s!important; }
.od-modal .ant-modal-close:hover { color:#fff!important; transform:rotate(90deg)!important; }
.od-modal .ant-modal-close .ant-modal-close-x { width:36px!important; height:36px!important; line-height:36px!important; }

/* ── Gradient header ── */
.od-header { background:linear-gradient(135deg,#003a8c 0%,#0050b3 35%,#1890ff 70%,#096dd9 100%); padding:18px 22px 16px; display:flex; align-items:center; gap:14px; position:relative; overflow:hidden; }
.od-header::before { content:''; position:absolute; inset:0; background-image:radial-gradient(rgba(255,255,255,.09) 1px,transparent 1px); background-size:20px 20px; pointer-events:none; }
.od-header::after  { content:''; position:absolute; bottom:0; left:0; right:0; height:3px; background:linear-gradient(90deg,#13c2c2,#1890ff,#52c41a,#fa8c16,#13c2c2); background-size:300% auto; animation:od-bar 3s linear infinite; }
.od-header-icon { width:44px; height:44px; border-radius:12px; background:rgba(255,255,255,.15); border:1.5px solid rgba(255,255,255,.25); display:flex; align-items:center; justify-content:center; flex-shrink:0; animation:od-glow 2.6s ease-in-out infinite, od-float 3s ease-in-out infinite; }
.od-header-title { font-size:15px; font-weight:800; color:#fff; letter-spacing:.8px; }
.od-header-sub   { font-size:11px; color:rgba(255,255,255,.6); letter-spacing:1px; margin-top:2px; }

/* ── Body ── */
.od-body { padding:20px 22px; min-height:180px; }

/* ── Tree overrides ── */
.od-modal .ant-tree { font-size:12px!important; font-weight:500!important; }
.od-modal .ant-tree li .ant-tree-node-content-wrapper:hover { background:#e6f7ff!important; border-radius:6px!important; }
.od-modal .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected { background:#bae7ff!important; border-radius:6px!important; font-weight:700!important; }
.od-modal .ant-tree-show-line .ant-tree-switcher { background:#fff!important; color:#1890ff!important; font-weight:700!important; }

/* ── Spin override ── */
.od-modal .ant-spin-dot-item { background:#1890ff!important; }

/* ── Empty result ── */
.od-modal .ant-result-title { font-size:13px!important; font-weight:700!important; color:#595959!important; letter-spacing:.5px!important; }
`;

const OverallDetailsModal = props => {
  const {
    visible,
    data: { id, po_num },
    closeModal,
  } = props;

  const [tree, setTrees] = useState({ treeData: [], treeDataParentKeys: [] });
  const { getPoDetails } = useContext(PContext);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (visible) {
      setLoading(true);
      getPoDetails(id)
        .then(res => {
          const { treeData, treeDataParentKeys } = res;
          setTrees({ treeData, treeDataParentKeys });
        })
        .finally(() => setLoading(false));
    }
  }, [visible]);

  return (
    <>
      <style>{modalStyles}</style>
      <Modal
        className="od-modal"
        onCancel={() => (isLoading ? null : closeModal())}
        style={{ top: 20 }}
        visible={visible}
        width="75%"
        footer={null}
        title={
          <div className="od-header">
            <div className="od-header-icon">
              <Icon type="profile" style={{ fontSize: 20, color: '#fff' }} />
            </div>
            <div>
              <div className="od-header-title">{po_num || 'PO DETAILS'}</div>
              <div className="od-header-sub">Purchase Order Overview</div>
            </div>
            <div style={{ marginLeft: 'auto' }}>
              <span style={{ display:'inline-flex', alignItems:'center', gap:5, background:'rgba(19,194,194,.2)', border:'1px solid rgba(19,194,194,.4)', borderRadius:20, padding:'3px 10px', fontSize:11, fontWeight:700, color:'#13c2c2', letterSpacing:'.5px' }}>
                <Icon type="partition" style={{ fontSize:10 }} />
                ITEM TREE
              </span>
            </div>
          </div>
        }
      >
        <div className="od-body">
          <Spin spinning={isLoading}>
            {tree.treeData.length > 0 ? (
              <Tree
                blockNode
                defaultExpandAll
                treeData={tree.treeData}
                showLine
              />
            ) : (
              <Result title="NO ITEMS" status="info" />
            )}
          </Spin>
        </div>
      </Modal>
    </>
  );
};

export default OverallDetailsModal;